export const appSettingsProductsData = "/app_settings/products_data";
